import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ruleManagementApis } from 'api'
import { RULE_MANAGEMENTS } from 'constans/queryKeys'
import * as urls from 'constans/urls'
import { useFormik } from 'formik'
import useToastify from 'hooks/useToastify'
import { useNavigate } from 'react-router-dom'
import { Container } from 'shared/components'
import { InsertRuleManagementRequestModel } from 'types/rule-managements'
import { formatDate } from 'utils/formatDate'
import * as yup from 'yup'
import CreateForm from './CreateForm'
import { INVALID_NUMBER, MAX_TEM_QUANTITY } from 'constans/gift-conditions'

const validationSchema = yup.object({
  ruleName: yup.string().required('Vui lòng nhập tên quy tắc!'),
  temStartTime: yup.string().required('Vui lòng nhập ngày  bắt đầu!'),
  temEndTime: yup.string().required('Vui lòng nhập ngày kết thúc!'),
  giftStartTime: yup.string().required('Vui lòng nhập ngày  bắt đầu!'),
  giftEndTime: yup.string().required('Vui lòng nhập ngày kết thúc!'),
  temQuantity: yup
    .number()
    .required('Vui lòng nhập số lượng tem!')
    .typeError(INVALID_NUMBER)
    .min(1, 'Số lượng tem phải lớn hơn 0!')
    .max(MAX_TEM_QUANTITY, `Số lượng tem không vượt quá ${MAX_TEM_QUANTITY}!`),
  totalBill: yup
    .number()
    .required('Vui lòng nhập giá trị hóa đơn!')
    .typeError(INVALID_NUMBER)
    .min(1, 'Giá trị hóa đơn phải lớn hơn 0!'),
  totalBillTo: yup
    .number()
    .required('Vui lòng nhập giá trị hóa đơn!')
    .typeError(INVALID_NUMBER)
    .min(1, 'Giá trị hóa đơn phải lớn hơn 0!'),
  createdUser: yup.string().required('Vui lòng nhập tên người tạo'),
})

const CreateRuleManagement = () => {
  const { showSuccess, showError } = useToastify()
  const navigate = useNavigate()
  const onBack = () => {
    navigate(`/${urls.RULE_MANAGEMENT_URLS.LIST}`)
  }
  const queryClient = useQueryClient()

  const { mutate } = useMutation({
    mutationFn: (val: InsertRuleManagementRequestModel) =>
      ruleManagementApis.insert(val),
    onSuccess: d => {
      if (d?.ErrorCode === 0) {
        showSuccess('Tạo quy tắc thành công')
        queryClient.invalidateQueries({
          queryKey: [RULE_MANAGEMENTS],
        })
        onBack()
      } else {
        showError('Đã xảy ra lỗi, vui lòng thử lại!')
      }
    },
    onError: e => {
      showError('Đã xảy ra lỗi, vui lòng thử lại!')
    },
  })

  const onSubmit = (val: InsertRuleManagementRequestModel) => {
    const newVal = { ...val }
    newVal.giftEndTime = formatDate(val.giftEndTime)
    newVal.giftStartTime = formatDate(val.giftStartTime)
    newVal.temEndTime = formatDate(val.temEndTime)
    newVal.temStartTime = formatDate(val.temStartTime)

    mutate(newVal)
  }
  const formik = useFormik<InsertRuleManagementRequestModel>({
    initialValues: {
      giftEndTime: '',
      giftStartTime: '',
      ruleId: undefined,
      ruleName: '',
      temEndTime: '',
      temQuantity: undefined,
      temStartTime: '',
      totalBill: undefined,
      totalBillTo: undefined,
      createdUser: '',
    },
    validationSchema,
    onSubmit,
  })

  return (
    <Container title="Tạo quy tắc tem">
      <CreateForm formik={formik} onBack={onBack} />
    </Container>
  )
}

export default CreateRuleManagement
